export default __webpack_public_path__ + "static/media/twin.eeb398e2.png";